import { Stack } from '@chakra-ui/react';
import { useTranslation } from 'i18n/TranslationProvider';
import AllUsersList from '../components/AllUsers/AllUsers';
import { PageHeader, PageShell } from 'components/layout/PageShell';

const AdminUsersPage = () => {
  const { t } = useTranslation();

  return (
    <PageShell>
      <Stack spacing={6}>
        <PageHeader
          title={t('Manage All Users')}
          description={t('Search, review, and maintain user accounts with one consistent admin workflow.')}
        />
        <AllUsersList />
      </Stack>
    </PageShell>
  );
};
export default AdminUsersPage;
